document.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>{document.querySelector('#main-photo').src=b.dataset.photo;document.querySelector('#main-photo').alt=b.getAttribute('aria-label');document.querySelectorAll('[data-photo]').forEach(x=>x.classList.toggle('active',x===b));}));

(()=>{
 const root=document.querySelector('.manita-site');
 const picker=root?.querySelector('.language-picker');
 const select=picker?.querySelector('select');
 const translations=window.manitaTranslations;
 if(!root||!select||!translations)return;
 const supported=['th','en','lo','vi','km'];
 function applyLanguage(language){
  if(!supported.includes(language))language='th';
  const dictionary=translations[language];
  root.querySelectorAll('[data-i18n]').forEach(element=>{const text=dictionary[element.dataset.i18n];if(typeof text==='string')element.textContent=text;});
  root.querySelectorAll('[data-i18n-aria]').forEach(element=>{const text=dictionary[element.dataset.i18nAria];if(typeof text==='string')element.setAttribute('aria-label',text);});
  document.documentElement.lang=language;
  root.lang=language;
  select.value=language;
  try{localStorage.setItem('manita-language',language);}catch{}
  try{const url=new URL(location.href);url.searchParams.set('lang',language);history.replaceState(null,'',url);}catch{}
 }
 let saved='';try{saved=localStorage.getItem('manita-language')||'';}catch{}
 const requested=new URLSearchParams(location.search).get('lang');
 const form=document.querySelector('#manita-localization');
 function syncLanguage(language){
  applyLanguage(language);
  if(form&&root.dataset.storeLanguage!==language){
   form.querySelector('[name="language_code"]').value=language;
   form.querySelector('[name="return_to"]').value='/?lang='+language;
   form.submit();
  }
 }
 syncLanguage(requested||saved||'th');
 select.addEventListener('change',()=>syncLanguage(select.value));
 picker.hidden=false;
})();
